import { put, call, select } from 'redux-saga/effects';
import {
  apiPeerProfilesGet,
  apiPeerProfilesInstrumentsGet,
  apiPeerProfilesSelectedInstrumentsGet,
} from '../api/peerProfile';
import {
  PEER_PROFILES_GET,
  PEER_PROFILES_INSTRUMENTS_GET,
  PEER_PROFILES_SELECTED_INSTRUMENTS_GET,
} from '../actions/types';
import { createQadraSaga } from './shared';

function* peerProfilesGet() {
  const peerProfiles = yield call(apiPeerProfilesGet);
  yield put({
    type: PEER_PROFILES_GET._SUCCESS,
    payload: { peerProfiles },
  });
}

const watchPeerProfilesGet = createQadraSaga(peerProfilesGet, {
  action: PEER_PROFILES_GET._REQUEST,
});

export function* peerProfilesInstrumentsGet({
  payload: { peerProfileId, startDate, endDate, numberOfClusters, refresh },
}) {
  if (refresh) {
    startDate = yield select((s) => s.peerProfiles.startDate);
    startDate = yield select((s) => s.peerProfiles.startDate);
    endDate = yield select((s) => s.peerProfiles.endDate);
    numberOfClusters = yield select((s) => s.peerProfiles.numberOfClusters);
    peerProfileId = yield select((s) => s.peerProfiles.peerProfileId);
  }

  const { clusteredInstruments } = yield call(apiPeerProfilesInstrumentsGet, peerProfileId, {
    startDate,
    endDate,
    numberOfClusters,
  });
  const clusteredInstrumentsMap = clusteredInstruments.reduce((map, item, i) => {
    return { ...map, [item.instrumentId]: { ...item, index: i } };
  }, {});
  yield put({
    type: PEER_PROFILES_INSTRUMENTS_GET._SUCCESS,
    payload: {
      startDate,
      endDate,
      numberOfClusters,
      peerProfileId,
      clusteredInstruments,
      clusteredInstrumentsMap,
    },
  });
}

const watchPeerProfilesInstrumentsGet = createQadraSaga(peerProfilesInstrumentsGet, {
  action: PEER_PROFILES_INSTRUMENTS_GET._REQUEST,
});

function* peerProfilesSelectedInstrumentsGet({ payload: { peerProfileId } }) {
  const { clusteredInstruments } = yield call(apiPeerProfilesSelectedInstrumentsGet, peerProfileId);
  const selectedInstrumentsMap = clusteredInstruments.reduce((map, item, i) => {
    return { ...map, [item.instrumentId]: { ...item, index: i } };
  }, {});
  yield put({
    type: PEER_PROFILES_SELECTED_INSTRUMENTS_GET._SUCCESS,
    payload: {
      peerProfileId,
      selectedInstruments: clusteredInstruments,
      selectedInstrumentsMap,
    },
  });
}

const watchPeerProfilesSelectedInstrumentsGet = createQadraSaga(
  peerProfilesSelectedInstrumentsGet,
  {
    action: PEER_PROFILES_SELECTED_INSTRUMENTS_GET._REQUEST,
  }
);

export default [
  watchPeerProfilesGet,
  watchPeerProfilesInstrumentsGet,
  watchPeerProfilesSelectedInstrumentsGet,
];
